import React, { useState, useEffect } from 'react';
import { string, node } from 'prop-types';
import './section-header-title.m.css';

const SectionHeaderTitle = ({ children, title, iconCode, className = "" }) => {
  const body = () => (
    <React.Fragment>
      {iconCode ? (
        <div styleName="icon-container">
          <i
            className={iconCode}
            style={{
              fontSize: `var(--base-medium)`,
              color: `var(--font4-color)`,
            }}
          />
        </div>
      ) : (
        children
      )}
      {title === 'IPOs' ? <span styleName="ipos-style">{title}</span> : title}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {className === "collection-name" ? (
        <h1
          styleName="section-header-title"
          className="section-header-title truncate-overflow"
          style={{ fontSize: '24px', display: 'inline-flex' }}
        >
          {body()}
        </h1>
      ) : (
        <h2
          styleName="section-header-title"
          className="section-header-title truncate-overflow"
          style={{ fontSize: '24px', display: 'inline-flex', padding: "4px 0" }}
        >
          {body()}
        </h2>
      )}
    </React.Fragment>
  );
};
SectionHeaderTitle.propTypes = {
  children: node,
  title: string.isRequired,
  iconCode: string,
};

SectionHeaderTitle.defaultProps = {
  children: null,
  iconCode: null,
};

export default SectionHeaderTitle;
